
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Card from 'vux/src/components/card/index.vue'

import EsQuery from "@/javascript/esQuery";
import Cpts014 from "@/components/lyx-components/menus/index.vue";
import util from "@/javascript/util";
import Swiper from "swiper";
import bus from "@/javascript/bus";

export default {
components: {
Group,
Cell,
Card,
Cpts014,
},
data() {
return {
showCover: true,
minHeight: 0,
cityData: [],
localPosition: {},
isLogin: false,
bannerImage: [
{
img: require('../../../assets/lyx-img/banner-center1.jpg'),
},
{
img: require('../../../assets/lyx-img/banner-center2.jpg'),
},
{
img: require('../../../assets/lyx-img/banner-center3.jpg'),
},
{
img: require('../../../assets/lyx-img/banner-center4.jpg'),
},
{
img: require('../../../assets/lyx-img/banner-center5.jpg'),
},
],
userInfo: localStorage.getItem('userInfo') ? localStorage.getItem('userInfo') : {},
wxUserInfo: {},
linkData: "/login",
nameData: "点击登录",
desData: "登录更精彩",
avatar: require('../../../assets/public-img/center_icon00.png'),
pointEntityData: false,
};
},














mounted() {
const _this = this;
document.title = _this.PAGE_TITLE + "我的";










_this.minHeight = document.documentElement.clientHeight;

setTimeout(function () {
_this.showCover = false;
}, 500);

setTimeout(function () {
_this.getUserInfo();
}, 500);

if (
localStorage.getItem("wxUserInfo") != null && localStorage.getItem("wxUserInfo") != ""
) {
_this.wxUserInfo = JSON.parse(localStorage.getItem("wxUserInfo"));
}
if (
localStorage.getItem("wxLoginTime") && localStorage.getItem("numberNo")
) {
console.log("+++++++++++wxLoginTime-mounted++++++++", localStorage.getItem("wxLoginTime"));
this.$router.push({ path: "/relation" });
}
},

methods: {
linkChange() {
this.$router.push({ path: this.linkData });
},
getUserInfo() {
const _this = this;
_this.isLogin = Boolean(localStorage.getItem('userInfo'));
if (_this.isLogin) {
_this.linkData = "/set";
let userInfoData = bus.userInfo.user;
const userId = userInfoData ? userInfoData.id : "";
if (userId) {
_this.$http.get("/api/wtcp-oauth/public/publicuser/" + userId + "?access_token=" + bus.userInfo.access_token).then((response) => {
console.log(response, 444)
if (response.status != 0) {
_this.nameData = response.data.data.nickname
? response.data.data.nickname
: _this.wxUserInfo.nickname
? _this.wxUserInfo.nickname
: response.data.data.name;
_this.desData = response.data.data.phone;
_this.$set(_this, "userInfo", response.data.data);
const wxinfo = localStorage.getItem("wxUserInfo");
if (wxinfo && !this.userInfo.avatar) {
_this.avatar = JSON.parse(wxinfo).headimgurl;
}
if (_this.userInfo.avatar) {
if (_this.userInfo.avatar.indexOf("http://") === -1) {
_this.avatar = _this.PIC_BASE_URL + _this.userInfo.avatar;
} else {
_this.avatar = _this.userInfo.avatar;
}
}
} else {
_this.linkData = "/login";
_this.nameData = "点击登录";
_this.desData = "登录更精彩";
_this.userInfo = {};
}

});
}
} else {
_this.linkData = "/login";
_this.nameData = "点击登录";
_this.desData = "登录更精彩";
_this.userInfo = {};
}
},
/**
* @msg: 菜单栏跳转
* @param {*} data
* @return {*}
*/
linkClick(data) {
const _this = this;

if (data.linkTrue) {
window.location.href = data.url;
} else {
_this.$router.push({ path: data.url });
}
},
},
created() {
const _this = this;

if (localStorage.getItem('wxUserInfo') != null && localStorage.getItem('wxUserInfo') != '') {
console.log('====wxUserInfo-created===', localStorage.getItem('wxUserInfo'))
_this.wxUserInfo = JSON.parse(localStorage.getItem('wxUserInfo'))
}
if (localStorage.getItem('userInfo') != null && localStorage.getItem('userInfo') != '') {
console.log('====wxUserInfo-created===', localStorage.getItem('userInfo'))
_this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
}
if (
localStorage.getItem("wxLoginTime") && localStorage.getItem("numberNo")
) {
this.$router.push({ path: "/relation" });
}
},
};
